import React from 'react';
import { Users, FileText, ArrowUpRight, ArrowDownRight, Activity } from 'lucide-react';

const stats = [
  { title: 'Novos Leads', value: '142', change: '+12.5%', trend: 'up', icon: Users },
  { title: 'Empresas Abertas', value: '28', change: '+5.2%', trend: 'up', icon: Activity },
  { title: 'Artigos Lidos', value: '1,429', change: '-2.1%', trend: 'down', icon: FileText },
];

export default function Dashboard() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-navy">Visão Geral</h1>
        <p className="text-slate-500">Bem-vindo ao Backoffice JWCosta.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {stats.map((stat, i) => (
          <div key={i} className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
            <div className="flex items-center justify-between mb-4">
              <div className="w-10 h-10 bg-slate-50 rounded-lg flex items-center justify-center text-slate-600">
                <stat.icon size={20} />
              </div>
              <div className={`flex items-center text-sm font-medium ${stat.trend === 'up' ? 'text-green-600' : 'text-red-600'}`}>
                {stat.trend === 'up' ? <ArrowUpRight size={16} /> : <ArrowDownRight size={16} />}
                {stat.change}
              </div>
            </div>
            <div>
              <div className="text-3xl font-bold text-navy">{stat.value}</div>
              <div className="text-sm text-slate-500 mt-1">{stat.title}</div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="bg-white rounded-2xl border border-slate-200 p-8 text-center">
        <div className="w-16 h-16 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <Activity size={32} />
        </div>
        <h3 className="text-lg font-bold text-navy mb-2">Área de Gráficos em Construção</h3>
        <p className="text-slate-500 max-w-sm mx-auto">
          Em breve você terá acesso a métricas avançadas de conversão e engajamento.
        </p>
      </div>
    </div>
  );
}
